import * as React from 'react';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { semanticSubApplication } from '@talend/data-quality-semantic-ee';
import { accountUtils, datasetSubApplication } from '@talend/dataset';
import { ConnectedEnginesErrorModal } from '@talend/engines';
import { LabsModal, useFlag } from '@talend/feature-flipping';
import { IconsProvider, Layout } from '@talend/react-components';
import { ConfirmDialog, ShortcutManager } from '@talend/react-containers';
import { ruleSubApplication } from '@talend/rule-core';
import { SubAppHostProvider } from '@talend/sub-app-system';

import { FEATURE_FLAGS, PATHS, TITLE } from '../../constants';
import { cadSubApplication } from '../../modules/CAD';
import { SidePanelEntries } from '../../types/sub-app-system';
import { ErrorPage } from '../ErrorPage';
import { ConnectedSidePanel } from '../SidePanel/SidePanel.connect';
import { getLandingUrl } from '../SidePanel/SidePanel.utils';
import { ConnectedHeader } from './Header';
import { useSidePanelEntries } from './SubApps';

export interface HomeProps {
	isGuidedTourOpened: boolean;
}

export function Home({ isGuidedTourOpened }: HomeProps): React.ReactElement {
	const [, setDisplay] = useState(false);
	const isTrrEnabled = useFlag(FEATURE_FLAGS.TDC_6383_TRR_IN_INVENTORY_ENABLED);
	const menuItems: SidePanelEntries = useSidePanelEntries();
	const engineErrorModalProps = { applicationName: 'Data Inventory' };
	const isSnowflake = accountUtils.isSnowflakeUser();

	const routes = [
		...semanticSubApplication.routes,
		...cadSubApplication.routes,
		...datasetSubApplication.routes,
	];

	if (isTrrEnabled) {
		routes.push(...ruleSubApplication.routes);
	}

	// FIXME : Hack to have the routing working on the / route, otherwise, it will not display the component
	// Can't find yet what's going on. It works before because we rely on useFlags that use redux and trigger a render
	useEffect(() => {
		setDisplay(true);
	}, []);

	return (
		<SubAppHostProvider defaultTitle={TITLE}>
			{!(isSnowflake && isGuidedTourOpened) && (
				<ConnectedEnginesErrorModal {...engineErrorModalProps} />
			)}
			<ConfirmDialog />
			<LabsModal />
			<IconsProvider additionalBundles={['/api/v1/icons']} />
			<ShortcutManager />
			<Layout
				hasTheme
				theme="qlik-light"
				mode={Layout?.DISPLAY_MODES.TWO_COLUMNS}
				header={<ConnectedHeader />}
				one={<ConnectedSidePanel menuItems={menuItems} />}
			>
				<Routes>
					<Route
						path="/"
						key="fallback-route"
						element={<Navigate to={getLandingUrl(menuItems)} replace />}
					/>
					{routes}
					<Route path={PATHS[403]} element={<ErrorPage />} />
					<Route path={PATHS[404]} element={<ErrorPage />} />
					<Route path="*" element={<Navigate to={PATHS[404]} />} />
				</Routes>
			</Layout>
		</SubAppHostProvider>
	);
}
